export default __webpack_public_path__ + "static/media/L_ROYT.4d2472d2.png";